import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {DirectModuleSelectionService} from 'shared/services/direct-module-selection/direct-module-selection.service';

@Injectable({
  providedIn: 'root'
})
export class DirectModuleSelectionGuard {
  constructor(
    private readonly service: DirectModuleSelectionService,
    private readonly router: Router
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const module = next.paramMap.get('module');
    if (module === 'm1' || module === 'm2') {
      this.service.enableDirectMode(module);
    }
    return this.router.parseUrl('analyzer');
  }
}
